import React from "react";

import { FooterText, FooterContainer, FooterContent } from "./Footer.styled";
import VersionLabel from "./VersionLabel";
import FooterLogo from "./FooterLogo";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo />
        <FooterText>
          Revenue Management - <VersionLabel />
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
